import { uniqueId } from 'lodash';
import React from 'react';

import { usePageContext } from '../../../providers/PageContext';
import ContactForm from './ContactForm';
import translations from './translations.json';

const ContactFormWrapper: React.FunctionComponent<any> = ({
  textColor,
  path,
}) => {
  const [state, setState] = React.useState({
    active: false,
    firstName: '',
    lastName: '',
    phone: '',
    company: '',
    email: '',
    orders: '',
    country: '',
    locations: '',
    comments: '',
  });
  const { siteTag, siteLang, countryCode } = usePageContext();

  const parentId = uniqueId('contact-form-parent-');
  const prefixId = uniqueId('contact-form-prefix-');

  const stateHandler = (newState: Partial<typeof state>) =>
    setState((prevState) => ({ ...prevState, ...newState }));

  // Kitchen park has multiple dialects of ar
  const langKey =
    siteTag === 'site:kitchenpark' &&
    ['ar-sa', 'ar-kw', 'ar-ae'].includes(siteLang)
      ? siteLang
      : siteLang.split('-')[0];

  const translate = translateTo({
    lang: langKey,
    translations,
    defaultLang: 'en',
  });

  const backwardsCompatibleSiteTag = siteTag.split(':')[1];

  return (
    <div id={parentId}>
      <ContactForm
        parentId={`#${parentId}`}
        prefixId={prefixId}
        stateHandler={stateHandler}
        translate={translate}
        siteTag={backwardsCompatibleSiteTag}
        countryCode={countryCode}
        color={textColor}
        path={path}
        langKey={langKey}
        {...state}
      />
    </div>
  );
};

function translateTo({ lang, translations, defaultLang }) {
  return (key) => {
    const text =
      translations?.[lang]?.[key] ?? translations?.[defaultLang]?.[key];
    // get(translations, [lang, key]) || get(translations, [defaultLang, key]);

    if (text) return text;

    throw new Error(`Missing translation for ["${lang}", "${key}"]`);
  };
}

export default ContactFormWrapper;
